import axios from "axios";
import { assertJsonResponse, internalApiHeaders } from "../utils/serviceHelper";
import { PSC_REGIME_TYPE, RegimeMappings } from "../types/regime";

/**
 * The regime (PSC) mappings held by the defect service — every Idwal defect
 * code that maps to one or more Paris/Tokyo MoU deficiency codes.
 *
 * This is one of the two `/defects` routes that needs a bearer token as well
 * as the API key: the internal API's key ships inside every CRA bundle, so the
 * mapping routes sit behind the authenticated authoriser too.
 *
 * Failures are logged rather than toasted. The mappings drive an
 * information-only column, so a reviewer losing it is a much smaller problem
 * than an error toast on every visit while the endpoint is down.
 */
export const getRegimeMappings = async (): Promise<RegimeMappings | null> => {
    const url = `${process.env.REACT_APP_IDWAL_INTERNAL_API}/defects/regime/${PSC_REGIME_TYPE}`;

    try {
        const response = await axios.get(url, {
            headers: await internalApiHeaders()
        });

        assertJsonResponse(response, url);

        // typeof can't tell an array from the keyed object we expect, and the
        // mappings are keyed by Idwal defect code.
        if (Array.isArray(response.data)) {
            throw new Error(
                `Expected regime mappings from ${url} to be keyed by defect code but got an array`
            );
        }

        return response.data;
    } catch (error) {
        console.warn(`Failed to get ${PSC_REGIME_TYPE} regime mappings`, error);

        return null;
    }
};
